import { render, staticRenderFns } from "./selectDataBank.vue?vue&type=template&id=4f48d05a&scoped=true"
import script from "./selectDataBank.vue?vue&type=script&lang=js"
export * from "./selectDataBank.vue?vue&type=script&lang=js"
import style0 from "./selectDataBank.vue?vue&type=style&index=0&id=4f48d05a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f48d05a",
  null
  
)

export default component.exports